<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";

export default {

	components: {
	  Layout
	},
   data() {
      return {           
         errors: {},
         script: null,
         style: null,
      };
   },

   created() {
          this.style = document.createElement('link')
          this.style.setAttribute('rel', 'stylesheet')
          this.style.setAttribute('href', '/design/terms-of-use.css')
          document.head.appendChild(this.style)
    },

    beforeDestroy() {
        document.head.removeChild(this.style);
    },

	mounted() {
	},

   methods: {
      
   }  
}
</script>
<template>
    <layout>
      <div class="container-sm py-5">
         <div class="order-success">
            <div>
               <img src="/design/sigofood-images/ordersuccess.png" alt="">
               <h4>Thank you for your order</h4>
               <router-link :to="{ name: 'orders' }" class="btn btn-warning btn-block mt-5 btn-theme">View Orders</router-link>
            </div>
         </div>
      </div>
    </layout>
</template>